import { PagePath, ParentPage } from '../types/common';

type PagePathParams = Omit<PagePath, '_id' | '_key'>

function getParent(data: ParentPage): string[] {
  if (data.parentPage) {
    return [
      ...getParent(data.parentPage),
      data.slug.current,
    ]
  }
  return [data.slug.current];
}

export function formatLink(pagePath: PagePathParams): string {
  if (!pagePath) return ''; 

  if (pagePath?._type && (pagePath?._type === 'articles' || pagePath?._type === 'News')) {
    return formatArticleLink(pagePath);
  }

  if (pagePath?._type && pagePath?._type === 'recipes') {
    return `/recipes/${pagePath.slug?.current}`;
  }

  if (pagePath?.parentPage && pagePath?.parentPage?.slug) {
    return `/${[...getParent(pagePath.parentPage), pagePath.slug?.current].join('/')}`;
  }

  return pagePath?.slug?.current ? `/${pagePath?.slug?.current}` : '#';
}

export function formatArticleLink(pagePath: PagePathParams): string {
  if (pagePath.slug) {
    return `/news/${pagePath.slug?.current}`;
  }
  return '';
}
